import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import React, { useEffect, useLayoutEffect, useState } from 'react';
import {
    fetchCustomers,
    SearchCustomers,
    SearchProducts,
    fetchProducts,
    fetchTecnnicians,
    SearchTechnicians,
    fetchBeacons,
    createAsset,
    fetchNoneBeacon
} from '@/apiCalls/apiCalls';
import { useDebounce } from '@/utils/DebounceHook';
import { errorNotification, successNotification } from '@/utils/Notification';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import { Products } from '../products/ProductsColumns';
import { Technicians } from '../technicians/TechniciansColumns';
import axios from 'axios';
import SpinnerForm from '../spinnner/SpinnerForm';


const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
interface AssetDrawerProps {
    showDrawer: boolean;
    setShowDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    getAssets: any
}
const AssetDrawer: React.FC<AssetDrawerProps> = ({ showDrawer, setShowDrawer, getAssets }) => {
    const onCLose = () => setShowDrawer(false);
    const [submitting, setSubmitting] = useState(false);
    const [searchTermForCustomer, setSearchTermForCustomer] = useState('')
    const [customerToDisplay, setCustomerToDisplay] = useState<any[]>([])
    const [customerOptions, setCustomerOptions] = useState([])
    const [searchTermForProducts, setSearchTermForProducts] = useState('')
    const [productsToDisplay, setProductsToDisplay] = useState<Products[]>([])
    const [productsOptions, setProductsOptions] = useState([])
    const [searchTermForTechnicians, setSearchTermForTechnicians] = useState('')
    const [techniciansToDisplay, setTechniciansToDisplay] = useState<Technicians[]>([])
    const [techniciansOptions, setTechniciansOptions] = useState([])
    const [loadingCustomers, setLoadingCustomers] = useState(true)
    const [loadingProducts, setLoadingProducts] = useState(true)
    const [loadingTechnicians, setLoadingTechnicians] = useState(true)
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()
    const [form] = Form.useForm();



    const getCustomers = () => {
        setLoadingCustomers(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/customers', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: any[]) => {
                if (isMounted) {
                    setCustomerToDisplay(data);
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            }).finally(() => {
                setLoadingCustomers(false)
            })
        return () => {
            isMounted = false
            controller.abort()
        }
    }

    useEffect(() => {
        getCustomers()
    }, [])

    const getProducts = () => {
        setLoadingProducts(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/products', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: Products[]) => {
                if (isMounted) {
                    setProductsToDisplay(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            }).finally(() => {
                setLoadingProducts(false)
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    useEffect(() => {
        getProducts()
    }, [])

    const getTechnicians = () => {
        setLoadingTechnicians(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/technicians', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: Technicians[]) => {
                if (isMounted) {
                    setTechniciansToDisplay(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            }).finally(() => {
                setLoadingTechnicians(false)
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    useEffect(() => {
        getTechnicians()
    }, [])





    const getClientIPAndURL = async () => {
        try {

            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }
    const onFinish = (assets: any) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.post('/api/v1/assets', assets, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "Beacon Store successfully added",
                    `${assets.name} was added to the system`,
                    'topRight'
                )
            }
            getAssets()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }


    const handleCustomerChange = (value: any) => {
        setSearchTermForCustomer(value)
    }
    const handleProductsChange = (value: any) => {
        setSearchTermForProducts(value)
    }
    const handleTechniciansChange = (value: any) => {
        setSearchTermForTechnicians(value)
    }


    const searchCustomerBySearchTerm = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get(`/api/v1/customers/search?query=${searchTermForCustomer}`, {
            signal: controller.signal
        }).then((response) => {
            if (isMounted) {
                setCustomerToDisplay(response.data.data)
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }

    useDebounce(searchTermForCustomer, 500, searchCustomerBySearchTerm)



    const searchProductsBySearchTerm = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get(`/api/v1/products/search?query=${searchTermForProducts}`, {
            signal: controller.signal
        }).then((response) => {
            if (isMounted) {
                setProductsToDisplay(response.data.data)
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }

    useDebounce(searchTermForProducts, 50, searchProductsBySearchTerm)


    const searchTechniciansBySearchTerm = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get(`/api/v1/technicians/search?query=${searchTermForTechnicians}`, {
            signal: controller.signal
        }).then((response) => {
            if (isMounted) {
                setTechniciansToDisplay(response.data.data)
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }

    useDebounce(searchTermForTechnicians, 50, searchTechniciansBySearchTerm)


    useEffect(() => {
        const updatedCustomerOptions: any = customerToDisplay.map((customer: any) => ({
            label: customer.name,
            value: customer.id
        }));
        setCustomerOptions(updatedCustomerOptions);
    }, [customerToDisplay])

    useEffect(() => {
        const updatedProductsOptions: any = productsToDisplay.map((product: any) => ({
            label: product.name,
            value: product.id
        }));
        setProductsOptions(updatedProductsOptions);
    }, [productsToDisplay])

    useEffect(() => {
        const updatedTechniciansOptions: any = techniciansToDisplay.map((technicians: any) => ({
            label: `${technicians.first_name} ${technicians.last_name}`,
            value: technicians.id
        }));
        setTechniciansOptions(updatedTechniciansOptions);
    }, [techniciansToDisplay])

   

    const filterCustomerOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false
    }

    const filterProductsOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false;
    }

    const filterTechniciansOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false;
    }
 



    const handleLivestockSelect = (value: any) => {
        console.log("Selected livestock ID:", value);
    }


    return <Drawer
        title="create Asset"
        width={720}
        onClose={onCLose}
        visible={showDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        style={{ backgroundColor: 'white' }}
        footer={
            <div
                style={{
                    textAlign: 'right',
                }}
            >
                <Button onClick={onCLose} style={{ marginRight: 8 }}>
                    Cancel
                </Button>
            </div>
        }
    >

        {(loadingCustomers) || (loadingProducts) || (loadingTechnicians) ? (
            <div>
                <SpinnerForm />
            </div>
        ) : (
            <Form layout="vertical"
                onFinishFailed={onFinishFailed}
                onFinish={onFinish}
                form={form}
                hideRequiredMark>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="customer_id"
                            label="Customer name"
                            rules={[{ required: true, message: 'Please select customer name' }]}
                        >
                            <Select
                                placeholder="Please select customer name"
                                showSearch
                                style={{ borderColor: 'black' }}
                                onSearch={handleCustomerChange}
                                filterOption={filterCustomerOptions}
                                onSelect={handleLivestockSelect}
                            >
                                {customerOptions.map((option: any) => (
                                    <Option key={option.value} value={option.value}>{option.label}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="product_id"
                            label="Product name"
                            rules={[{ required: true, message: 'Please slect product name' }]}
                        >
                            <Select
                                placeholder="Please select product name"
                                showSearch
                                style={{ borderColor: 'black' }}
                                onSearch={handleProductsChange}
                                filterOption={filterProductsOptions}
                                onSelect={handleLivestockSelect}
                            >
                                {productsOptions.map((option: any) => (
                                    <Option key={option.value} value={option.value}>{option.label}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="technician_id"
                            label="Technician name"
                            rules={[{ required: true, message: 'Please select technician name' }]}
                        >
                            <Select
                                placeholder="Please select technician name"
                                showSearch
                                onSearch={handleTechniciansChange}
                                filterOption={filterTechniciansOptions}
                                onSelect={handleLivestockSelect}
                            >
                                {techniciansOptions.map((option: any) => (
                                    <Option key={option.value} value={option.value}>{option.label}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="registration"
                            label="Registration"
                            rules={[{ required: true, message: 'Please enter registartion' }]}
                        >
                            <Input placeholder="Please enter registartion" autoComplete="off"/>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="client_name"
                            label="client name"
                            rules={[{ required: true, message: 'Please enter client name' }]}
                        >
                            <Input placeholder="Please enter client name" autoComplete="off" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="loan_id"
                            label="Loan Id"
                            rules={[{ required: true, message: 'Please enter loan id' }]}
                        >
                            <Input placeholder="Please enter loan id" className='focus:border-green-500 hover:border-green-500' autoComplete="off"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                                Submit
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    {submitting && <Spin indicator={antIcon} />}
                </Row>
            </Form>
        )}

    </Drawer>
}

export default AssetDrawer;


